import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { BusinessLoggerSiteConfig } from '../types'

const businessLoggerSiteConfig: SiteConfigFn<BusinessLoggerSiteConfig> = ({ api }) => {
	const isBuilderComponentModel = !!api.rendererModel.getSiteMetaData()?.builderComponentModel

	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: true,
		siteConfig: {
			isBuilderComponentModel,
		},
	}
}

const name = 'businessLogger'

export const config = { site: businessLoggerSiteConfig, reactNativeSite: businessLoggerSiteConfig, name }
